import {Text, StyleSheet} from '@react-pdf/renderer'
import React from 'react'

const styles = StyleSheet.create({
	empty:{
		marginBottom:'30px'
	},
})

export default () => ( <Text style={styles.empty}></Text> )



// WEBPACK FOOTER //
// ./src/react/ui/PDFCreation/Components/EmptySpace.js